module.exports = __webpack_public_path__ + "img/team-name.5bca199c.png";